// ANGULAR
import { provideRouter } from '@angular/router';
import { ApplicationConfig } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
// INTERCEPTORS
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { RefreshTokenInterceptor } from '@interceptors/refresh-token.interceptor';
// STORE
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MAIN_REDUCER } from '@store/main.reducer';
import { SessionEffects } from '@store/session/session.effects';
// OTHERS
import { routes } from 'src/app/app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    // Router
    provideRouter(routes),
    // HTTP (standalone way)
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    // Store (Clean Architecture: estado global por feature)
    provideStore(MAIN_REDUCER),
    // Effects (standalone replacement of EffectsModule.forRoot)
    provideEffects([SessionEffects]),
    // Interceptors (DI-based)
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
  ]
};